import { lazy } from 'react';

import type { Location } from '@core/Router/locations';

import { WALK_IN_EHR_ROUTE, WALK_IN_NAV_LINK, WALK_IN_REFERRALS_ROUTE } from './walkInRoutes';

const WalkInPage = lazy(() =>
    import(/* webpackChunkName: "walk-in" */ '../ui/WalkInPage').then(m => ({
        default: m.WalkInPage,
    })),
);
const LaboratoryEhrPage = lazy(() =>
    import(/* webpackChunkName: "walk-in" */ '@modules/walkIn/ui/LaboratoryPages/LaboratoryEhrPage').then(m => ({
        default: m.LaboratoryEhrPage,
    })),
);
const WalkInReferralsPage = lazy(() =>
    import(/* webpackChunkName: "walk-in" */ '../ui/WalkInReferralsPage').then(m => ({
        default: m.WalkInReferralsPage,
    })),
);

export const walkInLocations: Location[] = [
    {
        url: WALK_IN_NAV_LINK,
        Component: WalkInPage,
    },
    {
        url: WALK_IN_EHR_ROUTE.$path(),
        Component: LaboratoryEhrPage,
    },
    {
        url: WALK_IN_REFERRALS_ROUTE.$path(),
        Component: WalkInReferralsPage,
    },
];
